<template>
  <svg
    height="47"
    viewBox="0 0 45 47"
    width="45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      fill="#fff"
    ><path
      d="m0 .6966h44.3037v44.303h-44.3037z"
      fill="#fff"
      fill-rule="evenodd"
    /></mask>
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m44.3037 22.8486c0 12.235-9.918 22.151-22.15 22.151-12.236 0-22.154-9.916-22.154-22.151 0-12.231 9.918-22.152 22.154-22.152 12.232 0 22.15 9.921 22.15 22.152"
        fill="#fff"
        mask="url(#a)"
        transform="translate(0 .3037)"
      />
      <path
        d="m.291 23.1523c0 8.82 5.226 16.415 12.753 19.871v-39.744c-7.527 3.454-12.753 11.053-12.753 19.873"
        fill="#0045e6"
      />
      <path
        d="m44.0117 23.1523c0-8.82-5.226-16.419-12.751-19.873v39.744c7.525-3.456 12.751-11.051 12.751-19.871"
        fill="#f21830"
      />
      <path
        d="m22.1534 1.291c-3.255 0-6.338.717-9.109 1.988v39.744c2.771 1.275 5.854 1.989 9.109 1.989 3.25 0 6.334-.714 9.107-1.989v-39.744c-2.773-1.271-5.857-1.988-9.107-1.988"
        fill="#ffe60d"
      />
    </g>
  </svg>
</template>
